<template>
  <div>
    <div class="row center-block">
        <div class="col-md-12">
        <div class="box box-info">
            <form @submit.prevent class="form-horizontal">
            <div class="box-body">
                <div class="form-group col-md-5">
                    <label for="inputName">Name</label>
                    <h1 style="margin-top:0px;">
                        <input type="text" :disabled="true" class="form-control" placeholder="Invoice Number" v-model="formData.name">
                    </h1>                   
                </div>
                <div class="form-group col-md-7">
                <h3 style="margin-top:0px;">
                    <span class="label label-success pull-right">{{ formData.status}}</span>
                </h3>                     
                </div>
                <div class="row">
                <div class="col-md-12">
                    <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                        <li v-bind:class="{ active: tabActive == TAB_GENERAL }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">General Info</a></li>
                        <li v-bind:class="{ active: tabActive == TAB_ITEMS }"><a href="#tab_2" data-toggle="tab" aria-expanded="true">Items</a></li>
                        <li v-bind:class="{ active: tabActive == TAB_CARD_FEE }"><a href="#tab_3" data-toggle="tab" aria-expanded="true" v-on:click="inquiryCardFee">Card Fee</a></li>
                    </ul>
                    </div>
                    <div class="tab-content">
                      <div v-bind:class="{ active: tabActive == TAB_GENERAL }" class="tab-pane" id="tab_1">
                          <div class="box no-border form-horizontal">
                          <div class="row">
                              <div class="col-md-6">
                              <div class="form-group">
                                  <label for="comboCustomer" class="col-sm-4 control-label">Customer</label>
                                  <div class="col-sm-8">
                                  <input type="text" :disabled="true" class="form-control" v-model="formData.customerName">
                                  <!-- <select2 :id="'comboCustomer'" :options="listCustomer" :value="customerSelected" :enable="false" @change="onChangeCustomer($event)">
                                  </select2>                           -->
                                  </div>                     
                              </div>                                         
                              </div>
                              <div class="col-md-6">
                              <div class="form-group">
                                  <label for="inputDocumentDate" class="col-sm-4 control-label">Document Date</label>
                                  <div class="col-sm-8">
                                  <input type="text" :disabled="true" class="form-control" v-model="formData.documentDate">
                                  <!-- <div class="input-group">
                                      <datepicker style="width:100%" v-if="showDocumentDate" :readonly="true" name="documentDate" :value=formData.documentDate
                                                  :format=DATE_FORMAT :input-attr="{ 'id': 'documentDate', 'disabled': viewMode == MODE_VIEW ? true : false }"
                                                  :input-style="{ 'width': '100%' }"></datepicker>
                                  </div>                          -->
                                  </div> 
                              </div>                      
                              </div>
                          </div>                           
                          <div class="row">
                              <div class="col-md-6">
                              <div class="form-group">
                                  <label for="comboBillTo" class="col-sm-4 control-label">Bill To</label>
                                  <div class="col-sm-8">
                                  <input type="text" :disabled="true" class="form-control" v-model="formData.billToName">
                                  <!-- <select2 :id="'comboBillTo'" :options="listBillTo" :value="billToSelected" :enable="false">
                                  </select2>                           -->
                                  </div>                   
                              </div>                                         
                              </div>
                              <div class="col-md-6">
                              <div class="form-group">
                                  <label for="comboProject" class="col-sm-4 control-label">Project</label>
                                  <div class="col-sm-8">
                                  <input type="text" :disabled="true" class="form-control" v-model="formData.projectName">
                                  <!-- <select2 :id="'comboProject'" :options="listProject" :value="projectSelected" :enable="false">
                                  </select2>                           -->
                                  </div>
                              </div>                      
                              </div>
                          </div> 
                          <div class="row">
                              <div class="col-md-6">
                              <div class="form-group">
                                  <label for="comboCurrency" class="col-sm-4 control-label">Currency</label>
                                  <div class="col-sm-8">
                                  <input type="text" :disabled="true" class="form-control" v-model="formData.currencyName">
                                  <!-- <select2 :id="'comboCurrency'" :options="listCurrency" :value="currencySelected" :enable="false">
                                  </select2>                           -->
                                  </div>                   
                              </div>                                         
                              </div>
                              <div class="col-md-6">
                              <div class="form-group">
                                  <label for="inputGrossAmount" class="col-sm-4 control-label">Gross Amount</label>
                                  <div class="col-sm-8">
                                      <input type="text" :disabled="true" class="form-control" v-model="formData.grossAmount">
                                  </div>  
                              </div>                      
                              </div>
                          </div>
                          <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                    <label for="inputSO" class="col-sm-4 control-label">Sales Order</label>
                                    <div class="col-sm-8">
                                    <input type="text" :disabled="true" class="form-control" v-model="formData.salesOrderName">
                                    </div>                   
                                </div>                                         
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                    <label for="inputCostAmount" class="col-sm-4 control-label">Cost Amount</label>
                                    <div class="col-sm-8">
                                        <input type="text" :disabled="true" class="form-control" v-model="formData.costAmount">
                                    </div>  
                                </div>                      
                              </div>
                          </div>                            
                          <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">                 
                                </div>                                         
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                    <label for="inputTotalAmount" class="col-sm-4 control-label">Total Amount</label>
                                    <div class="col-sm-8">
                                        <input type="text" :disabled="true" class="form-control" v-model="formData.totalAmount">
                                    </div>  
                                </div>                      
                              </div>
                          </div>
                          </div>
                      </div>                        
                      <div v-bind:class="{ active: tabActive == TAB_ITEMS }" class="tab-pane" id="tab_2">
                          <div class="col-md-12">
                          <div class="box no-border">
                              <!-- <div class="box-header" style="height:40px;">          
                              <div class="box-tools">              
                                  <button @click="onCreateOrderItem" class="btn btn-primary">Create</button>
                              </div>
                              </div>                               -->
                              <div class="box-body no-padding table-responsive">
                              <table class="table table-striped">
                                  <thead>
                                  <tr>
                                      <th style="width:10px;text-align:right">#</th>
                                      <th style="text-align:left;">Product</th>
                                      <th style="text-align:left;">Description</th>
                                      <th style="text-align:right;">Quantity</th>
                                      <th style="text-align:right;">Unit Price</th>
                                      <th style="text-align:right;">Discount</th>
                                      <th style="text-align:right;">Tax</th>
                                      <th style="text-align:right;">Tax Amt</th>
                                      <th style="text-align:right;">Card Fee Amt</th>
                                      <th style="text-align:right;">3rd Party Amt</th>
                                      <th style="text-align:right;">Amount</th>
                                      <th style="text-align:center;">Currency</th>
                                      <th style="text-align:right;">BillPlan Seq</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="(row, i) in listInvoiceItem" v-bind:key="i">
                                      <td style="width:10px;text-align:right">{{ startSequence + i + 1}}</td>
                                      <td style="text-align:left;">{{ row.productName }}</td>
                                      <td style="text-align:left;">{{ row.productDescription }}</td>
                                      <td style="text-align:right;">{{ row.quantity }}</td>
                                      <td style="text-align:right;">{{ row.price }}</td>
                                      <td style="text-align:right;">{{ row.discount }}</td>
                                      <td style="text-align:right;">{{ row.tax }}</td>
                                      <td style="text-align:right;">{{ row.taxAmount }}</td>
                                      <td style="text-align:right;">{{ row.cardFeeAmount }}</td>
                                      <td style="text-align:right;">{{ row.thirdPartyAmount }}</td>
                                      <td style="text-align:right;">{{ row.amount }}</td>
                                      <td style="text-align:center;">{{ row.currencyName }}</td>
                                      <td style="text-align:right;">{{ row.billPlanSeqNo }}</td>
                                      <td hidden>{{ row.id }}</td>
                                      <td hidden>{{ row.productId }}</td>
                                      <td hidden>{{ row.invoiceId }}</td>
                                      <td hidden>{{ row.billPlanId }}</td>
                                      <td hidden>{{ row.currencyId }}</td>
                                  </tr>
                                  </tbody>
                              </table>
                              </div>
                          </div>
                          </div>
                      </div>
                      <div v-bind:class="{ active: tabActive == TAB_CARD_FEE }" class="tab-pane" id="tab_3">
                          <div class="col-md-12">
                          <div class="box-header with-border">
                            <span style="width:150px;" class="label label-warning pull-right"><h4>{{formData.cardFeeAmount}}</h4></span>                            
                          </div>                             
                          <div class="box no-border">
                              <!-- <div class="box-header" style="height:40px;">          
                              <div class="box-tools">              
                                  <button @click="onCreateOrderItem" class="btn btn-primary">Create</button>
                              </div>
                              </div>                               -->
                              <div class="box-body no-padding table-responsive">
                              <table class="table table-striped">
                                  <thead>
                                  <tr>
                                      <th style="width:10px;text-align:right">#</th>
                                      <th style="text-align:left;">Order No</th>
                                      <th style="text-align:right;">Amount</th>
                                      <th style="text-align:center;">Currency</th>
                                      <th style="text-align:left;">Card No</th>
                                      <th style="text-align:center;">Card Type</th>
                                      <th style="text-align:left;">Card Issuer</th>
                                      <th style="text-align:left;">Bank Issuer</th>
                                      <th style="text-align:right;">Fee(%)</th>
                                      <th style="text-align:right;">Fee(Amount)</th>
                                      <th style="text-align:right;">Fee</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="(row, i) in listCardFee" v-bind:key="i">
                                      <td style="width:10px;text-align:right">{{ startSequence + i + 1}}</td>
                                      <td style="text-align:left;">{{ row.orderNo }}</td>
                                      <td style="text-align:right;">{{ row.amount }}</td>
                                      <td style="text-align:center;">{{ row.currencyName }}</td>
                                      <td style="text-align:left;">{{ row.cardNo }}</td>
                                      <td style="text-align:center;">{{ row.cardType }}</td>
                                      <td style="text-align:left;">{{ row.cardIssuer }}</td>
                                      <td style="text-align:left;">{{ row.bankIssuer }}</td>
                                      <td style="text-align:right;">{{ row.feePercentage }}</td>
                                      <td style="text-align:right;">{{ row.feeAmount }}</td>
                                      <td style="text-align:right;">{{ row.fee }}</td>
                                  </tr>
                                  </tbody>
                              </table>
                              </div>
                          </div>
                          <div class="box-footer">
                            <!-- <button @click="onCalculateCardFee()" class="btn btn-primary" style="margin-right:15px;">Calculate Card Fee</button> -->
                            <button @click="onUpdateCostAmount()" class="btn btn-primary" style="margin-right:15px;" :disabled="formData.status == 'Verify' ? true : false">Update as Cost Amount</button>
                          </div>
                          </div>
                      </div>
                    </div>
                </div>                    
                </div>                 
                <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
                <input type="hidden" class="form-control" id="inputCustomerId" v-model="formData.customerId">
                <input type="hidden" class="form-control" id="inputBillToId" v-model="formData.billToId">
                <input type="hidden" class="form-control" id="inputProjectId" v-model="formData.projectId">
                <input type="hidden" class="form-control" id="inputCurrencyId" v-model="formData.currencyId">
            </div>

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>                
              </div>
              <button v-if="viewMode == MODE_VIEW" @click="onCancelPostingToSAP()" class="btn btn-info pull-right" style="margin-right:15px;">Cancel Post To SAP</button>
            </div>

            </form>
        </div>          
        </div>
    </div>
  </div>  
</template>

<script>
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import select2 from '../../components/widgets/Select2'
import utilities from '../../utilities'

const MODE_NONE = 'none'
// const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const TAB_GENERAL = 'tabGeneral'
const TAB_ITEMS = 'tabItems'
const TAB_CARD_FEE = 'tabCardFee'

export default {
  name: 'InvoiceForm',
  components: {
    datepicker, select2
  },
  data() {
    return {
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      TAB_GENERAL: TAB_GENERAL,
      TAB_ITEMS: TAB_ITEMS,
      TAB_CARD_FEE: TAB_CARD_FEE,
      item: null,
      listData: null,
      listDataTemp: null,
      listCurrency: null,
      listProject: null,
      listCustomer: null,
      listBillTo: null,
      listInvoiceItem: null,
      listInvoiceItemTemp: null,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        documentDate: '',
        customerId: 0,
        customerName: '',
        projectId: 0,
        projectName: '',
        billToId: 0,
        billToName: '',
        grossAmount: 0,
        costAmount: 0,
        cardFeeAmount: 0,
        totalAmount: 0,
        currencyId: 0,
        currencyName: '',
        sapDocument: '',
        status: '',
        salesOrderId: 0,
        salesOrderName: '',
        items: []
      },
      customerSelected: [],
      billToSelected: [],
      projectSelected: [],
      currencySelected: [],
      showDocumentDate: false,
      tabActive: '',
      startSequence: 0,
      listCardFee: null,
      listCardFeeTemp: null
    }
  },
  created() {
    if (this.$route.params) {
      this.callback = this.$route.params.callback
      this.formData.id = this.$route.params.id
      this.viewMode = this.$route.params.mode
    }

    this.tabActive = TAB_GENERAL
    this.getDetail()
  },
  mounted() {
  },
  methods: {
    inquiryCardFee() {
      api
        .request('Sales', 'get', '/api/SalesOrder/Inquiry?WhereClause=Id=' + this.formData.salesOrderId + '&PageSize=10&CurrentPageNumber=1&SortDirection=ASC&SortExpression=Name', null)
        .then(response => {
          return response.data.entity[0].reference
        })
        .then((posSessionName) => {
          this.getPOSSessionID(posSessionName)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getPOSSessionID(posSessionName) {
      api.request('POS', 'get', '/api/Session/Inquiry?WhereClause=Name=\'' + posSessionName + '\'&PageSize=10&CurrentPageNumber=1&SortDirection=ASC&SortExpression=Name', null)
        .then(response => {
          return response.data.entity[0].id
        })
        .then((posSessionID) => {
          this.getPOSCashFlow(posSessionID)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getPOSCashFlow(posSessionId) {
      api.request('POS', 'get', '/api/CashFlow/Inquiry?WhereClause=SessionId=' + posSessionId + '&PageSize=999999&CurrentPageNumber=1&SortDirection=ASC&SortExpression=Name', null)
        .then(response => {
          return response.data.entity
        })
        .then((cashFlow) => {
          this.getCardFee(cashFlow)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCardFee(cashFlow) {
      let cardsNo = []
      cashFlow.forEach(item => {
        if (item.cardNo !== '') {
          cardsNo.push(item.cardNo)
        }
      })

      api.request('Sales', 'options', '/api/Invoice/CardFee?ProjectId=' + this.formData.projectId, cardsNo)
        .then(response => {
          this.combineCardFee(cashFlow, response.data.entity)
        })
        .catch(error => {
          var message = error.message // + ':<br>' + error.response.data.errors.join('<br>')
          console.log(error)
          SweetAlert.fire('Error', message, 'error')
        })
    },
    combineCardFee(cashFlow, cardFees) {
      this.listCardFee = null
      // this.formData.costAmount = 0

      let listCardFeeCombine = []
      let cardFeeAmount = 0
      // let voidCashFlow = []
      let cashFlowTemp = cashFlow
      // console.log(cashFlowTemp)

      // cashFlow.forEach(item => {
      //   if (item.amount.indexOf('-') > -1) {
      //     voidCashFlow.push(item)
      //   }
      // })

      cashFlow.forEach(item => {
        if (item.amount.indexOf('-') > -1) {
          return
        }

        // let foundVoid = voidCashFlow.filter((x) => {
        //   return (x.name === item.name) && (x.amount.replace('-', '') === item.amount)
        // })[0]
        console.log(item.cardNo)
        let foundItem = cashFlowTemp.filter((x) => {
          return (x.name === item.name) && (x.amount.replace('-', '') === item.amount)
        })
        console.log(foundItem)
        if (foundItem.length % 2 === 0) {
          return
        }

        // let alreadyCombine = listCardFeeCombine.filter((x) => {
        //   return (x.orderNo === item.name.split('/')[0])
        // })[0]

        // if (alreadyCombine) {
        //   return
        // }
        if (item.cardNo !== '' || item.qrisId !== '') {
          let cardFee = cardFees.filter((x) => {
            return x.cardNo === item.cardNo
          })[0]
          console.log(cardFee)

          if (cardFee === undefined) {
            cardFee = cardFees.filter((x) => {
              return x.cardNo === item.qrisId.split('.')[0]
            })[0]
          }
          if (cardFee === undefined) {
            listCardFeeCombine.push({
              'orderNo': item.name.split('/')[0],
              'amount': item.amount,
              'currencyName': this.formData.currencyName,
              'cardNo': item.cardNo,
              'cardType': '',
              'cardIssuer': '',
              'bankIssuer': '',
              'feePercentage': '',
              'feeAmount': '',
              'fee': '0'
            })
          } else {
            let feePercent = utilities.ParseNumber(cardFee.feePercentage)
            let feeAmount = utilities.ParseNumber(cardFee.feeAmount)
            let amount = utilities.ParseNumber(item.amount)

            feeAmount = feePercent === 0 || feePercent === 'NaN' ? feeAmount : (feePercent / 100) * amount
            cardFeeAmount = cardFeeAmount + feeAmount
            feeAmount = utilities.DisplayNumber(feeAmount)

            listCardFeeCombine.push({
              'orderNo': item.name.split('/')[0],
              'amount': item.amount,
              'currencyName': this.formData.currencyName,
              'cardNo': item.cardNo,
              'cardType': cardFee.cardType,
              'cardIssuer': cardFee.cardIssuer,
              'bankIssuer': cardFee.bankIssuer,
              'feePercentage': cardFee.feePercentage,
              'feeAmount': cardFee.feeAmount,
              'fee': feeAmount
            })
          }
        }
      })
      this.listCardFee = listCardFeeCombine
      this.formData.cardFeeAmount = utilities.DisplayNumber(cardFeeAmount)
    },
    getDetail() {
      var me = this
      if (this.formData.id && this.formData.id !== 0) {
        api
          .request('Sales', 'get', '/api/Invoice/GetDetail?Id=' + this.formData.id, null)
          .then(response => {
            var data = response.data

            this.formData.id = data.entity.id
            this.formData.name = data.entity.name
            this.formData.documentDate = data.entity.documentDate
            this.formData.customerId = data.entity.customerId
            this.formData.projectId = data.entity.projectId
            this.formData.billToId = data.entity.billId
            this.formData.grossAmount = data.entity.grossAmount
            this.formData.costAmount = data.entity.costAmount
            this.formData.totalAmount = data.entity.totalAmount
            this.formData.currencyId = data.entity.currencyId
            this.formData.status = data.entity.status
            this.formData.salesOrderId = data.entity.salesOrderId
            this.formData.salesOrderName = data.entity.salesOrderName
            this.formData.sapDocument = data.entity.sapDocument

            this.listInvoiceItemTemp = data.entity.items
          })
          // Get Customer and BillTo Name
          .then(response => {
            var arrCustomer = []
            if (this.formData.customerId && this.formData.customerId !== '') {
              arrCustomer.push(this.formData.customerId)
            }
            if (this.formData.billToId && this.formData.billToId !== '') {
              arrCustomer.push(this.formData.billToId)
            }

            if (arrCustomer.length > 0) {
              let whereClause = 'id in (' + arrCustomer.join(',') + ')'
              api
                .request('Guest', 'get', '/api/Guest/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrCustomer.length +
                                              '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
                .then(response => {
                  var data = response.data
                  this.listCustomer = data.entity
                  let customerName = ''
                  let billToName = ''
                  this.listCustomer.some(function(itemCustomer, index) {
                    if (me.formData.customerId === itemCustomer.id) {
                      customerName = itemCustomer.firstName + ' ' + itemCustomer.lastName
                    }
                    if (me.formData.billToId === itemCustomer.id) {
                      billToName = itemCustomer.firstName + ' ' + itemCustomer.lastName
                    }
                  })
                  me.formData.customerName = customerName
                  me.formData.billToName = billToName
                })
            }
          })
          // Get Project Name
          .then(response => {
            let whereClause = 'id = ' + this.formData.projectId
            api
              .request('Account', 'get', '/api/Project/Inquiry?WhereClause=' + whereClause + '&PageSize=1' +
                                            '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
              .then(response => {
                var data = response.data
                if (data.entity) {
                  this.formData.projectName = data.entity[0].name
                }
              })
          })
          // Get Currency Name
          .then(response => {
            let whereClause = 'id = ' + this.formData.currencyId
            api
              .request('Account', 'get', '/api/Currency/Inquiry?WhereClause=' + whereClause + '&PageSize=1' +
                                            '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
              .then(response => {
                var data = response.data
                if (data.entity) {
                  this.formData.currencyName = data.entity[0].name
                }
              })
          })
          .then(response => {
            var arrProduct = []
            this.listInvoiceItemTemp.forEach(invoiceItem => {
              // Populate product
              arrProduct.push(invoiceItem.productId)
              var arrProductUnique = arrProduct.filter(function(item, index) {
                return arrProduct.indexOf(item) >= index
              })
              arrProduct = arrProductUnique
            })

            // Get product master
            let whereClause = 'id in (' + arrProduct.join(',') + ')'
            api
              .request('Sales', 'get', '/api/Product/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrProduct.length +
                                            '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
              .then(response => {
                var data = response.data
                this.listProduct = data.entity
                this.combineInquiryInvoiceItem()
              })
          })
          .catch(error => {
            var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
            SweetAlert.fire('Error', message, 'error')
          })
      }
    },
    combineInquiryInvoiceItem() {
      this.listInvoiceItemTemp.forEach(item => {
        let productName = ''
        let productDescription = ''
        this.listProduct.some(function(itemProduct, index) {
          if (item.productId === itemProduct.id) {
            productName = itemProduct.name
            productDescription = itemProduct.description
          }
        })
        item.productName = productName
        item.productDescription = productDescription
        item.currencyName = this.formData.currencyName
      })
      this.listInvoiceItem = this.listInvoiceItemTemp
    },
    getProjectDetail(id) {
      return api
        .request('Account', 'get', '/api/Project/GetDetail?Id=' + id, null)
        .then(response => {
          this.projectDetail = response.data.entity
        })
    },
    getCompanyDetail(id) {
      return api
        .request('Account', 'get', '/api/Company/GetDetail?Id=' + id, null)
        .then(response => {
          this.companyDetail = response.data.entity
        })
    },
    initForm() {
      this.formData.id = 0
      this.formData.name = ''
    },
    onEdit() {
      this.viewMode = MODE_UPDATE
    },
    onDisplay() {
      this.viewMode = MODE_VIEW
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      let name = this.callback[this.callback.length - 1].name
      let id = this.callback[this.callback.length - 1].id
      let mode = this.callback[this.callback.length - 1].mode
      this.callback.splice(this.callback.length - 1, 1)
      let params = {
        id: id,
        mode: mode,
        callback: this.callback
      }
      this.$router.push({ name: name, params: params })
    },
    // onCalculateCardFee() {
    //   if (this.listCardFee === null) {
    //     this.inquiryCardFee()
    //     SweetAlert.fire('Info', 'Card fee calculation was done successfully', 'info')
    //   }
    // },
    onUpdateCostAmount() {
      if (this.listCardFee === null) {
        this.listCardFee = []
      }
      const zeroFeeAmount = this.listCardFee.find(({ fee }) => fee === '0' || fee === '')
      if (zeroFeeAmount !== undefined) {
        SweetAlert.fire('Error', 'There are some zero card fee amount', 'error')
        return
      }

      let reqPayload = {
        Id: this.formData.id,
        GrossAmount: this.formData.grossAmount,
        CostAmount: this.formData.costAmount,
        CardFee: this.listCardFee
      }

      api
        .request('Sales', 'put', '/api/Invoice/CardFee', reqPayload)
        .then(response => {
          var data = response.data
          if (data.returnStatus) {
            SweetAlert.fire('Info', 'Updating card fee amount was done successfully', 'info')
            this.getDetail()
          } else {
            SweetAlert.fire('Error', data.returnMessage.join('<br>'), 'error')
          }
        })
    },
    cancelPostToSAP(params) {
      api
        .request('Sales', 'post', '/api/Invoice/CancelPostToSAP', params)
        .then(response => {
          console.log(response.data)
          var message = response.data.returnMessage.join('<br>')
          SweetAlert.fire('Info', message, 'info')
        })
        .then(response => {
          this.inquiryNew()
        })
    },
    onCancelPostingToSAP() {
      // Get Project and Company Detail
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'This process will reverse this SO Biling and automatically will cancel accounting doc in SAP',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          this.getProjectDetail(this.formData.projectId)
          .then(response => {
            this.getCompanyDetail(this.projectDetail.companyId)
              .then(response => {
                let params = {
                  Id: this.formData.id,
                  ProjectName: this.projectDetail ? this.projectDetail.name : '',
                  ProjectSAPCode: this.projectDetail ? this.projectDetail.sapCode : '',
                  ProjectBusinessArea: this.projectDetail ? this.projectDetail.businessArea : '',
                  ProjectBusinessUnit: this.projectDetail ? this.projectDetail.businessUnit : '',
                  CompanyId: this.companyDetail ? this.companyDetail.id : '',
                  CompanyName: this.companyDetail ? this.companyDetail.name : '',
                  CompanySAPCode: this.projectDetail ? this.companyDetail.sapCode : '',
                  BankAccountName: this.formData.BankAccountName,
                  BankAccountNo: this.formData.BankAccountNo,
                  BankAccountDescription: this.formData.BankAccountDescription,
                  SAPDocument: this.formData.sapDocument
                }
                this.cancelPostToSAP(params)
              })
          })
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
        }
      })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}
</style>



// WEBPACK FOOTER //
// InvoiceForm.vue?34d2819c